(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('docArticle', {
        templateUrl: 'views/components/views/docArticle/docArticle.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'base64', 'docArticleService', 'rememberService', function ($stateParams, stateService, utilityService, base64, docArticleService, rememberService) {

    		// #region VARIABLES & DEFINITIONS

            const vm = this;
            let docArticleKeyno = $stateParams.docarticle_keyno;
            
    		vm.model = {
                isHtml: true,
                bgDocArticleMain: {
                    selected: 'MAIN',
                    buttons: [
                        { id: 'MAIN', label: 'gb_docarticle_main', color: 'primary', onClick: () => setDocArticleMainView('MAIN') },
                        { id: 'ADMIN', label: 'gb_docarticle_admin', color: 'primary', onClick: () => setDocArticleMainView('ADMIN') }
                    ]
                },
                menu: {
                    html_content_base64: '',
                },
    			itemsListArticles: []
    		};

            // #endregion VARIABLES & DEFINITIONS

            // #region BUTTON RADIO FUNCTIONS

            function setDocArticleMainView(id) {
                vm.model.bgDocArticleMain.selected = vm.model.menu.gb_docarticle_main = id;
            }

            // #endregion BUTTON RADIO FUNCTIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadMenu() {
                vm.model.menu = (await docArticleService.getMenu({ docarticle_keyno: docArticleKeyno }))[0];

                vm.model.menu.html_content_base64 = base64.urldecode(vm.model.menu.html_content_base64);

                setDocArticleMainView(vm.model.menu.gb_docarticle_main);
                loadArticles();
            }

            async function loadArticles() {
                if (utilityService.validateParmsValue(vm.model.menu.docarticle_keyno) !== true) return;

                vm.model.itemsListArticles = (await docArticleService.listArticles({ docarticle_keyno: vm.model.menu.docarticle_keyno }));
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgDocArticleMain = function (value) {
                vm.model.bgDocArticleMain.selected = value;
                vm.model.menu.gb_docarticle_main = vm.model.bgDocArticleMain.selected;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                let go = function (parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                };

                switch (state) {
                    case 'docarticleedit':
                        rememberService.remember('docarticle_keyno_belongto', vm.model.menu.docarticle_keyno).then(() => {
                            go({ docarticle_keyno: '0' });
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadMenu();
            };

            // #endregion ON INIT FUNCTION

    	}]
    });
})();
